import _has from 'lodash/has';
import _get from 'lodash/get';

import { ADDITIONAL_TODOS_DATA } from './stubs';

/**
 * @param {typeof import("../stubs").DEFAULT_TODOS} todos
 * @param {boolean} hideCompleted
 * @returns {{
 *  id: string,
 *  isDone: boolean,
 *  title: string,
 *  description: string,
 *  linkText: string,
 *  linkTo?: string
 * }[]}
 * */
export function createAdditionalTodos(todos = {}, hideCompleted = false) {
  const tasks = Object.entries(ADDITIONAL_TODOS_DATA).reduce(
    (acc, [taskId, data]) => {
      const hasTodo = _has(todos, taskId);
      if (hasTodo) {
        const isDone = _get(todos, taskId, false);
        if (!hideCompleted || (hideCompleted && !isDone)) {
          acc.push({ id: taskId, isDone, ...data });
        }
      }
      return acc;
    },
    []
  );

  tasks.sort((a, b) => {
    if (a.isDone === b.isDone) return 0;
    if (a.isDone && !b.isDone) return 1;
    return -1;
  });

  return tasks;
}
